import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header/Header";
import ProgressBar from "../../components/progressBar/ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/actions/CartActions";
import pricing from "../../assets/data/pricing.json";
import { addToServiceList } from "../../redux/actions/ServiceListActions";
import {
  updateAdminRequest,
  updateBusinessRequest,
  updateDomiciliationRequest,
  updateGrhRequest,
  updateJuridiqueRequest,
  updateManagementRequest,
  updateSalesRequest,
} from "../../redux/actions/RequestActions";
import serviceCode from "../../assets/data/serviceCode.json";
import Swal from "sweetalert2";
import Loader from "../../components/loader/Loader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaCheck } from "react-icons/fa";

const protectionOptions = [
  {
    label: "Oui",
    value: true,
    description:
      "Nous procéderons à la protection de votre nom d'entreprise via l'Organisation Africaine de la Propriété Intellectuelle (OAPI), afin d'éviter que d'autres entités l'utilisent.",
    icon: <FaCheck size={35} color="green" />,
  },
];

function EditOapi() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentStep = "Services";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const { user } = useSelector((state) => state.authUser);
  const {
    businessCreationRequest,
    domiciliationRequest,
    managementRequest,
    juridiqueRequest,
    adminRequest,
    grhRequest,
    salesRequest,
  } = useSelector((state) => state.request);
  const [submitting, setSubmitting] = useState(false);
  const servicesList = useSelector((state) => state.serviceList.services);
  const cart = useSelector((state) => state.cart);

  // Handle option selection
  const handleOptionSelect = async (option) => {
    if (option) {
      setSubmitting(true);

      let updatedServices = [...servicesList];
      updatedServices.push({
        code: serviceCode.oapi,
        billing: "lifetime",
      });
      if (cart.from === "creation") {
        await dispatch(
          updateBusinessRequest(
            user.token,
            businessCreationRequest.reference,
            {
              services: [...updatedServices],
            },
            handleCallback
          )
        );
      } else if (cart.from === "domiciliation") {
        await dispatch(
          updateDomiciliationRequest(
            user.token,
            domiciliationRequest.reference,
            {
              services: [...updatedServices],
            },
            handleCallback
          )
        );
      } else if (cart.from === "management") {
        await dispatch(
          updateManagementRequest(
            user.token,
            managementRequest.reference,
            {
              services: [...updatedServices],
            },
            handleCallback
          )
        );
      } else if (cart.from === "admin") {
        await dispatch(
          updateAdminRequest(
            user.token,
            adminRequest.reference,
            {
              services: [...updatedServices],
            },
            handleCallback
          )
        );
      } else if (cart.from === "juridique") {
        await dispatch(
          updateJuridiqueRequest(
            user.token,
            juridiqueRequest.reference,
            {
              services: [...updatedServices],
            },
            handleCallback
          )
        );
      } else if (cart.from === "grh") {
        await dispatch(
          updateGrhRequest(
            user.token,
            grhRequest.reference,
            {
              services: [...updatedServices],
            },
            handleCallback
          )
        );
      } else if (cart.from === "sales") {
        await dispatch(
          updateSalesRequest(
            user.token,
            salesRequest.reference,
            {
              services: [...updatedServices],
            },
            handleCallback
          )
        );
      }
    } else {
      navigate(-1, { replace: true });
    }
  };

  const handleCallback = async ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      await dispatch(
        addToCart({
          oapi: {
            amount: pricing.oapi,
          },
        })
      );

      await dispatch(
        addToServiceList({
          code: serviceCode.oapi,
          billing: "lifetime",
        })
      );

      navigate(-1, { replace: true });
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  const handleSkipClick = () => {
    navigate(-1, { replace: true });
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <Header />
      <Loader isLoading={submitting} />
      <ProgressBar steps={steps} currentStep={currentStep} />

      {/* Title Section */}
      <div className="container mt-4 text-center" style={{ maxWidth: "800px" }}>
        <h4 className="text-2xl font-semibold">
          Voulez-vous <span style={{ color: "#FF5500" }}>sécuriser</span> le nom
          de votre entreprise en l'enregistrant auprès de l'
          <span style={{ color: "#FF5500" }}>OAPI</span> ?
        </h4>
      </div>

      {/* Option Selection Boxes */}
      <div className="container mt-4 d-flex justify-content-center">
        <div className="row w100" style={{ maxWidth: "600px" }}>
          {protectionOptions.map((option, index) => (
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id={`tooltip-${index}`}>{option.description}</Tooltip>
              }
            >
              <div className="mb-4" key={index}>
                <div
                  className="option-box d-flex align-items-center justify-content-center flex-column"
                  onClick={() => handleOptionSelect(option.value)}
                  style={{
                    height: "200px",
                    width: "200px",
                    border: "2px solid #ddd",
                    borderRadius: "8px",
                    padding: "20px",
                    cursor: "pointer",
                    transition: "border-color 0.3s",
                    textAlign: "center",
                    color: "#000",
                    position: "relative",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.borderColor = "#FF5500")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.borderColor = "#ddd")
                  }
                >
                  {option.icon}

                  <span style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
                    {option.label}
                  </span>
                </div>
              </div>
            </OverlayTrigger>
          ))}
        </div>
      </div>

      <div className="container text-center mt-5">
        <span
          onClick={handleSkipClick}
          style={{ color: "#3392FF", cursor: "pointer" }}
        >
          Retour
        </span>
      </div>
    </div>
  );
}

export default EditOapi;
